import React from 'react'

import * as CHANNEL_TYPES from 'remote/channels/types'

import * as Icons from 'components/Utils/Icons'

export default function ChannelIcon({
  channel = undefined,
  filled = false,
  type = channel && channel.type,
  useNewIcons = false,
  isExpanded = false,
  ...props
}) {
  // type = channel ? channel.type : type
  if (useNewIcons) {
    if (type === CHANNEL_TYPES.PERSONAL) {
      return <Icons.LockIcon {...props} size={14} />
    }
    if (type === CHANNEL_TYPES.PRIVATE) {
      return <Icons.LockIcon {...props} size={14} />
    }
    if (isExpanded) {
      return <Icons.ChannelOpenIcon {...props} size={16} />
    }
    return <Icons.ChannelClosedIcon {...props} size={14} />
  }

  switch (type) {
    case CHANNEL_TYPES.PRIVATE: {
      return filled ? (
        <Icons.LockFilledIcon {...props} />
      ) : (
        <Icons.LockIcon {...props} />
      )
    }
    case CHANNEL_TYPES.PERSONAL:
      return <Icons.ArobaseIcon {...props} />
    case CHANNEL_TYPES.PUBLIC:
    default:
      return filled ? (
        <Icons.CircleIcon {...props} />
      ) : (
        <Icons.ThinCircleEmptyIcon {...props} />
      )
  }
}
